import Request from './request'

const CompanyTariffs  = {
  getTariffs(params, callback) {
    Request.get('company-tariffs', params).then(callback).catch(this.bad_answer)
  },
  getTariffList(params, callback) {
    Request.get('company-tariffs/list').then(callback).catch(this.bad_answer)
  },
  getServices(callback) {
    Request.get('company-tariffs/services').then(callback).catch(this.bad_answer)
  },
  createTariff(params, callback) {
    Request.post('company-tariffs/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getTariffInfo(id, callback) {
    Request.get('company-tariffs/view/' + id).then(callback).catch(this.bad_answer)
  },
  updateTariffInfo(id, params, callback) {
    Request.post('company-tariffs/update/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default CompanyTariffs
